import * as style from './Reviews.css';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';
import { REVIEWS } from 'shared/constants/reviews';
import { Review } from '../Review';
import { TReview } from 'shared/types/reviews';
import { ReviewModal } from '../ReviewModal';
import { ReactNode } from 'react';
import { REVIEWS_SLIDER_SETTINGS } from 'shared/constants/sliderSettings';
import Slider from 'react-slick';

interface IReviewsProps {
  isOpen: boolean;
  onChangeOpen: VoidFunction;
  onClickReview: (id: number) => void;
  activeReview?: TReview;
}

export const Reviews: React.FC<IReviewsProps> = ({ isOpen, activeReview, onClickReview, onChangeOpen }) => {
  const device = useDeviceType();

  const wrapContent = (content: ReactNode) => {
    return device === 'desktop' ? content : <Slider {...REVIEWS_SLIDER_SETTINGS}>{content}</Slider>;
  };

  return (
    <div className={clsx(style['container'], style[device])}>
      {wrapContent(REVIEWS.map(item => <Review {...item} key={item.id} onClickButton={onClickReview} />))}
      <ReviewModal isOpen={isOpen} onCloseModal={onChangeOpen} review={activeReview} />
    </div>
  );
};
